import { render, staticRenderFns } from "./TradingOrderTransactionItems.vue?vue&type=template&id=13c0a288&scoped=true&"
import script from "./TradingOrderTransactionItems.vue?vue&type=script&lang=js&"
export * from "./TradingOrderTransactionItems.vue?vue&type=script&lang=js&"
import style0 from "./TradingOrderTransactionItems.vue?vue&type=style&index=0&id=13c0a288&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c0a288",
  null
  
)

export default component.exports